import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-document-download',
  standalone: true,
  imports: [],
  templateUrl: './icon-document-download.component.html',
  styleUrl: './icon-document-download.component.scss'
})
export class IconDocumentDownloadComponent {
  @Input() color: string = 'currentColor';
  @Input() size: string = '26px';
}
